module.exports = __webpack_public_path__ + "static/media/Preeti M.478c82f9.png";